var w = Object.defineProperty;
var p = (e, t, n) => t in e ? w(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var h = (e, t, n) => p(e, typeof t != "symbol" ? t + "" : t, n);
class L {
  constructor() {
    h(this, "events", /* @__PURE__ */ new Map());
    h(this, "ignoreEvents", []);
    h(this, "stopHandleEvent", !1);
  }
  on(t, n) {
    const o = this.events.get(t);
    return o ? o.push(n) : this.events.set(t, [n]), this;
  }
  handleEvent(t, ...n) {
    if (!this.stopHandleEvent && this.ignoreEvents.indexOf(t) < 0) {
      const o = this.events.get(t);
      o && o.forEach((r) => {
        r && r(...n);
      });
    }
  }
  startEventHandle(t) {
    if (t) {
      const n = this.ignoreEvents.indexOf(t);
      n >= 0 && this.ignoreEvents.splice(n, 1);
    } else
      this.stopHandleEvent = !1;
  }
  stopEventHandle(t) {
    t ? this.ignoreEvents.push(t) : this.stopHandleEvent = !0;
  }
  clearEventHandle() {
    this.events.clear();
  }
}
const R = (e, t) => [t, e], A = () => "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(e) {
  var t = Math.random() * 16 | 0, n = e === "x" ? t : t & 3 | 8;
  return n.toString(16);
}), f = (e) => e < 26 ? e + 65 : e < 52 ? e + 71 : e < 62 ? e - 4 : e === 62 ? 43 : e === 63 ? 47 : 65, C = (e) => {
  let t = 2, n = "";
  for (let o = e.length, r = 0, s = 0; s < o; s++)
    t = s % 3, s > 0 && s * 4 / 3 % 76 === 0 && (n += `\r
`), r |= e[s] << (16 >>> t & 24), (t === 2 || e.length - s === 1) && (n += String.fromCharCode(
      f(r >>> 18 & 63),
      f(r >>> 12 & 63),
      f(r >>> 6 & 63),
      f(r & 63)
    ), r = 0);
  return n.substr(0, n.length - 2 + t) + (t === 2 ? "" : t === 1 ? "=" : "==");
}, H = (e) => {
  let t, n, o = e.length, r = 0;
  for (let s = 0; s < o; s++)
    n = e.charCodeAt(s), r += n < 128 ? 1 : n < 2048 ? 2 : n < 65536 ? 3 : n < 2097152 ? 4 : n < 67108864 ? 5 : 6;
  t = new Uint8Array(r);
  for (let s = 0, i = 0; s < r; i++)
    n = e.charCodeAt(i), n < 128 ? t[s++] = n : n < 2048 ? (t[s++] = 192 + (n >>> 6), t[s++] = 128 + (n & 63)) : n < 65536 ? (t[s++] = 224 + (n >>> 12), t[s++] = 128 + (n >>> 6 & 63), t[s++] = 128 + (n & 63)) : n < 2097152 ? (t[s++] = 240 + (n >>> 18), t[s++] = 128 + (n >>> 12 & 63), t[s++] = 128 + (n >>> 6 & 63), t[s++] = 128 + (n & 63)) : n < 67108864 ? (t[s++] = 248 + (n >>> 24), t[s++] = 128 + (n >>> 18 & 63), t[s++] = 128 + (n >>> 12 & 63), t[s++] = 128 + (n >>> 6 & 63), t[s++] = 128 + (n & 63)) : (t[s++] = 252 + (n >>> 30), t[s++] = 128 + (n >>> 24 & 63), t[s++] = 128 + (n >>> 18 & 63), t[s++] = 128 + (n >>> 12 & 63), t[s++] = 128 + (n >>> 6 & 63), t[s++] = 128 + (n & 63));
  return t;
}, S = (e, t, n, o) => ({
  x: e + n / 2,
  y: t + o / 2
}), T = (e, t) => ({
  x: t.x - e.x,
  y: t.y - e.y
}), F = (e, t) => t.left <= e.left && t.left + t.width >= e.left + e.width && t.top <= e.top && t.top + t.height >= e.top + e.height, O = (e, t, n = !1) => {
  let { left: o, top: r, width: s, height: i } = e;
  const a = s / i;
  if (o < 0 && (n && (s += o, i = s / a), o = 0), o + s > t.width)
    if (n) {
      var c = o + s - t.width;
      s -= c, i = s / a;
    } else
      o = t.width - s;
  if (r < 0 && (n && (i += r, s = i * a), r = 0), r + i > t.height)
    if (n) {
      const l = r + i - t.height;
      i -= l, s = i * a;
    } else
      r = t.height - i;
  return { left: o, top: r, width: s, height: i };
}, P = (e, t) => {
  const n = t.width / e.width, o = t.height / e.height, r = Math.min(n, o), s = e.width * r, i = e.height * r, a = (t.width - s) / 2, c = (t.height - i) / 2;
  return { left: a, top: c, width: s, height: i };
}, B = (e) => {
  let t = { left: 0, top: 0, width: 0, height: 0 };
  for (let n = 0; n < e.length; ++n) {
    const o = e[n];
    if (n === 0)
      t = { ...o };
    else {
      const r = t.left + t.width, s = t.top + t.height, i = o.left + o.width, a = o.top + o.height;
      t.left > o.left && (t.left = o.left), t.top > o.top && (t.top = o.top), r < i && (t.width = r - t.left), s < a && (t.height = s - t.top);
    }
  }
  return t;
}, x = async (e) => {
  if (e.length === 0)
    throw new Error("invalid source");
  return new Promise((t, n) => {
    let o = -1;
    const r = document.createElement("img");
    r.crossOrigin = "*", r.onerror = (i) => {
      clearTimeout(o), n(i);
    }, r.src = e;
    function s() {
      E(r) ? t(r) : o = window.setTimeout(s, 100);
    }
    s();
  });
}, N = async (e) => await navigator.permissions.query({
  name: e
}), k = (e) => {
  let t = e.split(","), n = t[0].match(/:(.*?);/)[1], o = atob(t[1]), r = o.length, s = new Uint8Array(r);
  for (; r--; )
    s[r] = o.charCodeAt(r);
  return new Blob([s], { type: n });
}, W = (e) => {
  const t = [];
  return e.forEach((n) => {
    n && t.push(n);
  }), t;
}, U = () => {
  const e = () => ((1 + Math.random()) * 65536 | 0).toString(16).substring(1);
  return e() + e() + "-" + e() + "-" + e() + "-" + e() + "-" + e() + e() + e();
}, V = (e) => {
}, _ = (e) => new Promise((t) => setTimeout(t, e));
class j {
  constructor(t, n = !1) {
    const o = t.toString(), r = new Blob(["(" + o + ")()"]);
    return n ? new SharedWorker(URL.createObjectURL(r)) : new Worker(URL.createObjectURL(r));
  }
}
const v = (e) => e * Math.PI / 180, g = (e) => Math.floor(e * 180 / Math.PI), D = (e, t, n, o) => {
  const r = Math.atan2(o - t, n - e);
  return g(r);
}, G = (e, t, n, o, r, s) => g(Math.atan((o - s) / (n - r)) - Math.atan((t - s) / (e - r))), d = (e, t, n, o, r) => {
  const s = v(r), i = (e - n) * Math.cos(s) - (t - o) * Math.sin(s) + n, a = (e - n) * Math.sin(s) + (t - o) * Math.cos(s) + o;
  return { x: Math.floor(i), y: Math.floor(a) };
}, $ = (e, t, n, o) => {
  let r = !1, s = e.left, i = e.top, a = e.width ? e.left + e.width : void 0, c = e.height ? e.top + e.height : void 0;
  if (n && o) {
    const l = d(e.left, e.top, o.x, o.y, -n);
    if (s = l.x, i = l.y, e.width && e.height) {
      const u = d(e.left + e.width, e.top + e.height, o.x, o.y, -n);
      a = u.x, c = u.y;
    }
  }
  return t.left < s && t.top < i && t.left + t.width > (a || s) && t.top + t.height > (c || i) && (r = !0), r;
}, q = (e) => {
  var t;
  e instanceof HTMLVideoElement && (e.srcObject instanceof MediaStream ? e.srcObject.getTracks().forEach((n) => {
    n.stop();
  }) : (e.pause(), e.src = ""), (t = e.parentElement) == null || t.removeChild(e), e.remove());
}, E = (e) => e instanceof HTMLVideoElement ? e.readyState === HTMLMediaElement.HAVE_ENOUGH_DATA && e.videoWidth > 0 : e instanceof HTMLImageElement ? e.complete && e.naturalWidth > 0 : !0, b = (e, t, n) => {
  t < 0 && (t = 0), t > e.length && (t = e.length), n < 0 && (n = 0), n > e.length && (n = e.length), [e[t], e[n]] = [e[n], e[t]];
}, z = (e, t, n, o = !1) => {
  if (t < 0 && (t = 0), t > e.length && (t = e.length), n < 0 && (n = 0), n > e.length && (n = e.length), o)
    b(e, t, n);
  else {
    const r = e.splice(t, 1);
    e.splice(n, 0, r[0]);
  }
}, J = (e, t) => {
  const n = e.indexOf(t);
  n >= 0 && e.splice(n, 1);
}, y = async (e) => await (await fetch(e)).blob(), m = async (e) => new Promise((t, n) => {
  const o = new FileReader();
  o.onload = (r) => t(o.result), o.onerror = (r) => n(o.error), o.onabort = (r) => n(new Error("Read aborted")), o.readAsDataURL(e);
}), I = (e, t, n, o, r) => {
  const s = n !== -1 ? n : e.length;
  for (let i = t; i < s; ++i)
    if (e[i].indexOf(o) === 0 && (!r || e[i].toLowerCase().indexOf(r.toLowerCase()) !== -1))
      return i;
  return null;
}, K = (e, t, n) => I(e, 0, -1, t, n), Q = async (e) => {
  try {
    const t = await y(e);
    return new DOMParser().parseFromString(await t.text(), "text/xml");
  } catch {
  }
}, X = async (e) => {
  try {
    const t = new XMLSerializer(), n = new Blob([t.serializeToString(e)], { type: "image/svg+xml" }), o = await m(n);
    return await x(o);
  } catch {
  }
}, Z = (e) => {
  const t = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  e = e.replace(t, function(o, r, s, i) {
    return r + r + s + s + i + i;
  });
  const n = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e);
  return n ? {
    r: parseInt(n[1], 16),
    g: parseInt(n[2], 16),
    b: parseInt(n[3], 16)
  } : null;
}, Y = (e, t, n) => "#" + ((1 << 24) + (e << 16) + (t << 8) + n).toString(16).slice(1), tt = (e) => {
  e = e.toLowerCase().replaceAll(" ", "");
  const t = /rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)/.exec(e);
  if (t instanceof Array && t.length >= 3) {
    const n = parseInt(t[0], 10), o = parseInt(t[1], 10), r = parseInt(t[2], 10);
    if (!(isNaN(n) || isNaN(o) || isNaN(r)))
      return { r: n, g: o, b: r };
  }
  return null;
};
export {
  L as BaseEventHandler,
  j as WebWorker,
  O as adjustRectInFrame,
  _ as asyncSleep,
  C as base64EncArr,
  m as blobToDataURL,
  S as calcCenterCoordinate,
  T as calcDistance,
  P as calcFillToFrame,
  B as calcOutlineRect,
  z as changeArrayItem,
  N as checkForPermission,
  U as createGuid,
  x as createImage,
  k as dataURLtoBlob,
  y as downloadBlob,
  K as findLine,
  I as findLineInRange,
  D as getAngle,
  G as getAngleFromPoints,
  d as getRotatePoint,
  Z as hexToRGB,
  E as isImageReady,
  F as isRectInFrame,
  Q as loadSVG,
  $ as pointInRect,
  J as removeArrayItem,
  W as removeNullEntries,
  q as removeVideoElement,
  tt as rgbFromRgbColorFormat,
  Y as rgbToHex,
  V as sleep,
  H as strToUTF8Arr,
  X as svgToImage,
  R as swap,
  b as swapArrayItem,
  g as toDegrees,
  v as toRadians,
  f as uint6ToB64,
  A as uuidv4
};
//# sourceMappingURL=index.es.js.map
